import { PUSH_ALL_MESSAGES, PUSH_NOTIFICATION, REMOVE_MESSAGE, SET_APP_TYPE } from "../actions/types";

export default function(state = {}, action) {
  switch (action.type) {
    case PUSH_NOTIFICATION: {
      return {
        ...state,
        preventDuplicate: action.payload.preventDuplicate ? action.payload.preventDuplicate : false,
        message: {
          type: action.payload.type,
          content: action.payload.message,
          persist: action.payload["persist"],
          removePrevious: action.payload["removePrevious"]
        }
      };
    }
    case SET_APP_TYPE: {
      return {
        ...state,
        appType: action.payload
      };
    }
    case PUSH_ALL_MESSAGES: {
      return {
        ...state,
        allMessages: action.payload
      };
    }
    case REMOVE_MESSAGE: {
      return { ...state, message: undefined };
    }
    default:
      return state;
  }
}
